import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDirectory = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 57,
	height: 57,
	viewBox: "0 0 57 57",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4668 16.6463C11.4668 15.2253 11.4668 14.5147 11.7477 13.9739C11.9845 13.5182 12.3561 13.1466 12.8118 12.9098C13.3526 12.6289 14.0632 12.6289 15.4842 12.6289H25.9703C26.5748 12.6289 26.877 12.6289 27.1621 12.6968C27.4044 12.7545 27.6368 12.8482 27.8514 12.9747C28.1038 13.1235 28.3215 13.3332 28.7569 13.7525L29.0146 14.0006C29.45 14.4199 29.6677 14.6296 29.9201 14.7784C30.1347 14.9049 30.3671 14.9986 30.6094 15.0563C30.8945 15.1242 31.1967 15.1242 31.8012 15.1242H42.3833C43.8043 15.1242 44.5148 15.1242 45.0557 15.4051C45.5114 15.6419 45.883 16.0135 46.1197 16.4692C46.4007 17.01 46.4007 17.7205 46.4007 19.1416V43.0588C46.4007 43.7693 46.4007 44.1246 46.2602 44.395C46.1418 44.6229 45.956 44.8087 45.7282 44.927C45.4578 45.0675 45.1025 45.0675 44.392 45.0675H15.0825C13.8035 45.0675 13.1641 45.0675 12.6773 44.8147C12.2671 44.6016 11.9327 44.2672 11.7196 43.857C11.4668 43.3703 11.4668 42.7308 11.4668 41.4519V16.6463Z",
			fill: "url(#paint0_linear_14670_214964)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 8.97234,
			y: 16.3727,
			width: 46.9284,
			height: 33.6862,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(2.5px)",
					clipPath: "url(#bgblur_0_14670_214964_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-figma-bg-blur-radius": 4.99055,
			d: "M24.0742 21.4795H47.0869C48.0852 21.4795 48.8213 21.4803 49.374 21.5596C49.9236 21.6384 50.2692 21.7926 50.5049 22.083C50.7405 22.3734 50.8203 22.7437 50.7842 23.2979C50.7478 23.8551 50.5973 24.5759 50.3916 25.5527L46.8711 42.2705C46.7306 42.9377 46.6272 43.4281 46.5 43.8008C46.3738 44.1703 46.2288 44.4117 46.0117 44.5879C45.7945 44.7641 45.5283 44.857 45.1406 44.9043C44.7498 44.952 44.249 44.9521 43.5674 44.9521H14.2178C14.7682 44.2946 15.0692 43.6124 15.3652 42.6465C15.5273 42.1178 15.6894 41.5009 15.8906 40.7568C16.0921 40.0118 16.3332 39.1357 16.6553 38.085C17.5816 35.0629 19.7041 27.7859 20.8291 23.916C21.0063 23.3066 21.1361 22.859 21.2793 22.5195C21.4213 22.183 21.5719 21.9646 21.7822 21.8066C21.9927 21.6486 22.2446 21.5649 22.6074 21.5225C22.9733 21.4797 23.4396 21.4795 24.0742 21.4795Z",
			fill: "#B9DDFF",
			fillOpacity: .6,
			stroke: "url(#paint1_linear_14670_214964)",
			strokeWidth: .232851
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7051 15.2178H22.6953C23.3329 15.2178 23.8496 15.7355 23.8496 16.373C23.8494 17.0104 23.3327 17.5273 22.6953 17.5273H17.7051C17.0676 17.5273 16.55 17.0105 16.5498 16.373C16.5498 15.7354 17.0675 15.2178 17.7051 15.2178Z",
			fill: "url(#paint2_linear_14670_214964)",
			fillOpacity: .9,
			stroke: "url(#paint3_linear_14670_214964)",
			strokeWidth: .186281
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_14670_214964_clip_path",
				transform: "translate(-8.97234 -16.3727)",
				children: /* @__PURE__ */ _jsx("path", { d: "M24.0742 21.4795H47.0869C48.0852 21.4795 48.8213 21.4803 49.374 21.5596C49.9236 21.6384 50.2692 21.7926 50.5049 22.083C50.7405 22.3734 50.8203 22.7437 50.7842 23.2979C50.7478 23.8551 50.5973 24.5759 50.3916 25.5527L46.8711 42.2705C46.7306 42.9377 46.6272 43.4281 46.5 43.8008C46.3738 44.1703 46.2288 44.4117 46.0117 44.5879C45.7945 44.7641 45.5283 44.857 45.1406 44.9043C44.7498 44.952 44.249 44.9521 43.5674 44.9521H14.2178C14.7682 44.2946 15.0692 43.6124 15.3652 42.6465C15.5273 42.1178 15.6894 41.5009 15.8906 40.7568C16.0921 40.0118 16.3332 39.1357 16.6553 38.085C17.5816 35.0629 19.7041 27.7859 20.8291 23.916C21.0063 23.3066 21.1361 22.859 21.2793 22.5195C21.4213 22.183 21.5719 21.9646 21.7822 21.8066C21.9927 21.6486 22.2446 21.5649 22.6074 21.5225C22.9733 21.4797 23.4396 21.4795 24.0742 21.4795Z" })
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_14670_214964",
				x1: 21.5439,
				y1: 19.7248,
				x2: 47.903,
				y2: 29.4868,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#7FC0FB" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#003399"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_14670_214964",
				x1: 12.0914,
				y1: 23.0565,
				x2: 25.3221,
				y2: 54.962,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: .765625,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_14670_214964",
				x1: 15.8881,
				y1: 14.9583,
				x2: 26.1335,
				y2: 17.9853,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_14670_214964",
				x1: 15.1895,
				y1: 15.6568,
				x2: 20.1999,
				y2: 17.6203,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgDirectory);
export { ForwardRef as ReactComponent };
